import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CustomerVerificationFlowConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	showHeaderAndFooterForNDCFlow(): boolean {
		return this.configService.get<boolean>((x) => x.matCoreUi.dialogHeaderFooterNDC, false);
	}
}
